export const retryAfter = (value: number): string => {
  const DIVIDER_VALUE = 60;

  const hours = Math.floor(value / DIVIDER_VALUE / DIVIDER_VALUE);
  const minutes = Math.floor(value / DIVIDER_VALUE) % DIVIDER_VALUE;
  const seconds = value % DIVIDER_VALUE;

  const strings = [];

  if (hours > 0) {
    strings.push(`${hours}h`);
  }

  if (minutes > 0) {
    strings.push(`${minutes}m`);
  }

  strings.push(`${seconds}s`);

  return strings.join(" ");
};
